export default __webpack_public_path__ + "static/media/HaiwayChanel.88a6a52c.jpg";